import axios from "axios";
import { clearToken, getToken } from "./cookies";
import { routes } from "@/app/routes/paths";


export const api = axios.create({
	baseURL: import.meta.env.VITE_API_URL,
	withCredentials: true,
});


api.interceptors.request.use((config) => {
	const token = getToken();
	if (token) config.headers.Authorization = `Bearer ${token}`;
	return config;
});

// response interceptor to handle errors
api.interceptors.response.use((response) => {
	return response;
}, (error) => {
	if (error.response.status === 401) {
		clearToken();
		if (window.location.pathname !== routes.LOGIN_PATH) {
			window.location.href = routes.LOGIN_PATH;
		}
	}

	return Promise.reject(error);
});